import axios from "../../axios";

const complete = async function (accessToken,uuid = {}) {
    try {
        const response = await axios.post('admin/pay-out/complete', {}, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default complete;
